import React from "react";
import { classNames } from "../../helpers/classNames";

const normalize = (val) => (val || "").toString().trim().toLowerCase();

const STATUS_STYLES = {
  success: "bg-emerald-100 text-emerald-700 border border-emerald-600/50",
  danger: "bg-rose-100 text-rose-700 border border-rose-600/50",
  warning: "bg-amber-100 text-amber-700 border border-amber-600/50",
  info: "bg-sky-100 text-sky-700 border border-sky-600/50",
  pending: "bg-violet-100 text-violet-700 border border-violet-600/50",
  processing:
    "bg-orange-100 text-orange-700 border border-orange-600/50 relative",
  cancelled: "bg-gray-200 text-gray-700 border border-gray-600/50",
  confirmed: "bg-green-200 text-green-800 border border-green-600/50",
  partialRefund: "bg-yellow-100 text-yellow-800 border border-yellow-600/50",
  default: "bg-gray-100 text-gray-700 border border-gray-600/50",
};

const inferType = (label) => {
  const l = normalize(label);
  if (/(success|completed|complete|approved|paid)/.test(l)) return "success";
  if (/(cancel(l)?ed)/.test(l)) return "cancelled";
  if (/(fail|failed|error|declined|rejected)/.test(l)) return "danger";
  if (/(warn|warning|hold|issue)/.test(l)) return "warning";
  if (/(info|information)/.test(l)) return "info";
  if (/(processing|in\s*progress|running)/.test(l)) return "processing";
  if (/(pending|queued|await)/.test(l)) return "pending";
  if (/(confirm|confirmed)/.test(l)) return "confirmed";
  if (/(partial\s*refund)/.test(l)) return "partialRefund";
  return "default";
};

const Badge = ({
  type,
  label = "Label",
  className,
  inferTypeFromLabel = true,
}) => {
  const key = type || (inferTypeFromLabel ? inferType(label) : "default");
  const statusColor = STATUS_STYLES[key] ?? STATUS_STYLES.default;

  return (
    <div
      className={classNames(
        "whitespace-nowrap truncate capitalize font-semibold text-center py-1 px-3 rounded-full text-sb w-fit",
        statusColor,
        className
      )}
    >
      {label}
    </div>
  );
};

export default Badge;
